import goTo from 'vuetify/es5/services/goto';

export default {
  scrollToTop() {
    goTo(0, { easing: 'easeInOutCubic', duration: 300}); // MLD-3968
  },
  scrollToSelector(selector) {
    goTo(selector, { easing: 'easeInOutCubic', duration: 300}); // MLD-3968
  },
}
